import React from "react";
import ClientrmTable from "./ClientrmTable";
import axios from "axios";
import { useEffect, useState } from "react";
import Select from "react-select";
import AprmTable from "./AprmTable";
import { toast } from "react-toastify";
import { Constants } from "../../CommonMethhods/Constants";
import { Rm_Ap_Mapping } from "../../Configuration/API_URL";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { useDebounce } from "../../Components/useDebounce";
import Loader from "../../Components/Common/Loader";

function ClientrmMapping() {
  const [optionVal, setOptionVal] = useState([]);
  const [rmVal, setRmVal] = useState([]);
  const [rmReport, setRmReport] = useState([]);
  const [page, setPage] = useState(1);
  const [rmPage, setRmPage] = useState(1);
  const [clientShow, setClientShow] = useState(false);
  const [rmShow, setRmShow] = useState(false);
  const [clientCode, setClientCode] = useState({ value: "", label: "" });
  const [rmName, setRmName] = useState({ value: "", label: "" });
  const [isupdate, setIsUpdate] = useState(false);
  const [clientID, setClientID] = useState("");
  const [errorClCode, setErrorClCode] = useState("");
  const [errorClientRmName, setErrorClientRmName] = useState("");
  const [scrollClCodeLoader, setScrollClCodeLoader] = useState(false);
  const [scrollRmLoader, setScrollRmLoader] = useState(false);
  const [serverError, setServerError] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [tableErr, setTableErr] = useState("");
  const [loaderMain, setLoaderMain] = useState(false);


  function childUpdate(data) {    
    // document.querySelector("#SearchInput_Rm").value = data.rmName;
    // document.querySelector("#SearchInput_Client").value = data.clientCode;
    setClientCode({value: data?.clientCode, label: data?.clientName});
    setRmName({value: data?.rmCode, label: data?.rmName})
    setIsUpdate(true);
    setClientID(data.id);
  }

  const debouncedValue = useDebounce(clientCode, 1000);

  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  const rmDebouncedVal = useDebounce(rmName, 1000);

  useEffect(() => {
    handleRmName(rmDebouncedVal)
  }, [rmDebouncedVal]);

  const searchDebouncedVal = useDebounce(searchVal, 1000);

  useEffect(() => {
    if (searchDebouncedVal === "") {
      RMClientMappingReport("grid", "");
    } else {
      RMClientMappingReport("grid", searchDebouncedVal);
    }
  }, [searchDebouncedVal]);

  // useEffect(() => {
  //   RMClientMappingReport("grid", "");
  // }, []);

  useEffect(() => {
    if (rmPage > 1 || rmName === "") {
      GetRMName();
    }
  }, [rmPage, rmName]);

  useEffect(() => {
    if (page > 1 || clientCode === "") {
      GetClientCode();
    }
  }, [page, clientCode]);

  const processResponse = (data) => {
    const finalRes = [];
    if (data.length > 0) {
      data.map((data, index) => {
        let Object = {
          value: data.value,
          label: data.name,
        };
        finalRes.push(Object);
      });
    }
    return finalRes;
  };

  const handleScroll = async () => {
    const a = document.querySelector("#getclient_code");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      setPage((prev) => prev + 1);
      setScrollClCodeLoader(true);
    }
  };

  const handleRmScroll = async () => {
    const a = document.querySelector("#getRm_code");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      setRmPage((prev) => prev + 1);
      setScrollRmLoader(true);
    }
  };

  function handleClientName(value) {
    setOptionVal([]);
    setPage(1);
    if (value) {
      GetClientCode();
    }
  }

  // function getClientName(label, value) {
  //   setClientCode({ label, value });
  // }

  const GetClientCode = async () => {
    // let client = document.querySelector("#SearchInput_Client").value;
    let payloadValue = {
      search: clientCode?.value || "",
      pageNo: page,
      pageSize: 10
    };

    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValuename");

    try {
      const response = await axios.post(
        Rm_Ap_Mapping.Get_Client_Code_URL,
        `"${encPayload}"`,

        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(response?.data);

      if (res.status === 0) {
        // setOptionVal(processResponse(data.data.clients));
        setOptionVal((prev) => {
          return [...prev, ...processResponse(res.data.clients)];
        });
        setErrorClCode("");
      } else {
        setOptionVal([]);
        setErrorClCode(res.message);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setScrollClCodeLoader(false);
    }
  };

  function handleRmName(data) {
    setRmVal([]);
    setRmPage(1);
    if (data) {
      GetRMName();
    } else {
      setErrorClCode(false);
      setErrorClientRmName(false);
    }
    // if (e.targe.value === "") {
    //     setErrorClCode(false);
    //     setErrorClientRmName(false);
    //   }
  }

  const GetRMName = async () => {
    // let rmName = document.querySelector("#SearchInput_Rm").value;
    let payloadValue = {
      search: rmName?.value || "",
      pageNo: rmPage,
      pageSize: "10"
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const response = await axios.post(
        Rm_Ap_Mapping.Get_RM_Name_URL,

        `"${encPayload}"`,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(response?.data);

      if (res.status === 0) {
        setRmVal((prev) => {
          return [...prev, ...processResponse(res.data.clients)];
        });
        setScrollRmLoader(true);
        // setRmVal(processResponse(res.data.clients));
      } else {
        setRmVal([]);
        setErrorClientRmName(res.message);
      }
    } catch (err) {
    } finally {
      setScrollRmLoader(false);
    }
  };

  function reset() {
    // document.querySelector("#SearchInput_Rm").value = "";
    // document.querySelector("#SearchInput_Client").value = "";
    setRmName({ value: "", label: "" });
    setClientCode({ value: "", label: "" });
    setIsUpdate(false);
  }

  const saveClientName = async (clientObject, rmObject) => {
    let payloadValue = {
      clientCode: clientObject?.label,
      clientName: clientObject?.value,
      rmCode: rmObject?.value,
      rmName: rmObject?.label,
    };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValue000");
    
    try {
      const response = await axios.post(
        Rm_Ap_Mapping.Save_Client_Rm_Code_Name_URL,

        `"${encPayload}"`,

        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const data = ApiResDecrypt(response?.data);
      if (data.status === 0) {
        toast.success(data.data.message);
        RMClientMappingReport("grid", "");
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const UpdateClientRM = async (clientID, rmName) => {
    
    let payloadValue = {
      id: clientID,
      rmCode: rmName?.value,
      rmName: rmName?.label,
    };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValueUpdate");
    
    try {
      const response = await axios.post(
        Rm_Ap_Mapping.Update_Client_RM_URL,
        `"${encPayload}"`,

        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const data = ApiResDecrypt(response.data);
      if (data.status === 0) {
        toast.success(data.data.message);
        setIsUpdate(false);
        RMClientMappingReport("grid", "");
      } else {
        toast.error(data.message);
      }
    } catch (err) { }
  };

  const RMClientMappingReport = async (fileType, value = "") => {
    setLoaderMain(true)
    let payloadValue = { type: fileType, search: value };
    let encPayload = AESEncryption(payloadValue);
    try {
      const response = await axios.post(
        Rm_Ap_Mapping.RM_Client_Mapping_Report_URL,

        `"${encPayload}"`,
        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 1,
          },
        }
      );
      const data = ApiResDecrypt(response?.data);
      if (data.status === 0) {
        setTableErr("");
        if (fileType === "grid") {
          setRmReport(data?.data);
        } else {
          window.open(data?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (fileType === "grid") {
          setTableErr(data?.message)
          setRmReport([])
        } else if (fileType === "excel") {
          toast.error(data?.message);
        }
      }
    } catch (err) {
      setServerError("Somthing went wrong please try again later");
    }
    finally {
      setLoaderMain(false)
    }
  };

  const showClientCode = () => {
    setClientShow(true);
  };

  const handleSaveSubmit = (button) => {
      if (
        clientCode.value &&
        clientCode.label &&
        rmName.value &&
        rmName.label
      ) {
        if (button === "update") {
          UpdateClientRM(clientID, rmName);
        } else {
          saveClientName(clientCode, rmName);
        }
      } else {
        toast.error("All field are mandatory");
      }
    };

  return (
    <div className="card-box">
      <div className="row align-items-center">
        <div className="col-md-4 col-sm-6 col-12">
          <div className="form-group">
            <label className="form-label">Client Code:</label>
            <div className="rm-custom-dropdown">
              <input
                type="text"
                name="search-text"
                id="SearchInput_Client"
                className="input-st"
                placeholder="Search by Name/Code..."
                autoComplete="off"
                onFocus={() => showClientCode()}
                value={clientCode?.value}
                // defaultValue={clientCode?.label}
                onChange={(e) => {
                  setClientCode({ value: e?.target?.value?.toUpperCase(), label: "" })
                  // handleClientName(e);
                }}

                onInput={(e) => {
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;
                  let input = e.target.value;
                  input = input
                    .toUpperCase()
                    .replace(/[^A-Z0-9\s]/g, "")
                    .replace(/\s+/g, " ")
                    .trimStart()
                    .slice(0, 100);

                  e.target.value = input;
                  e.target.setSelectionRange(start, end);
                }}
              />
              <button
                className="rm-dropdown-btn"
                onClick={() => setClientShow(!clientShow)}
              >
                <span className="icon-right-arrow-triangle"></span>
              </button>
              {clientShow && (
                <>
                  <ul
                    className="rm-mapping-ap border-0"
                    onScroll={handleScroll}
                    id="getclient_code"
                  >
                    {optionVal.map((item, i) => (
                      <li
                        key={i}
                        onClick={() => {
                          document.querySelector("#SearchInput_Client").value =
                            item.label;
                          setClientShow(false);
                          setClientCode({value: item?.value, label: item?.label});
                        }}
                        className="rm-maping-item-wrapper"
                      >
                        <div> {item.value}</div>
                        <div> {item.label}</div>
                      </li>
                    ))}
                    {scrollClCodeLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}

                    {errorClCode && (
                      <div className="rm-maping-no-data">{errorClCode}</div>
                    )}
                  </ul>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-4 col-sm-6 col-12">
          <div className="form-group">
            <label className="form-label">RM Name: </label>
            <div className="rm-custom-dropdown">
              <input
                type="text"
                name="search-text"
                id="SearchInput_Rm"
                className="input-st"
                placeholder="Search by Name/Code..."
                autoComplete="off"
                onFocus={() => setRmShow(true)}
                // defaultValue={rmName?.value}
                value={rmName?.label}
                onChange={(e) => {
                  setRmName({ value: "", label: e?.target?.value?.toUpperCase() })
                  // handleRmName(e);
                }}
                onInput={(e) => {
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;
                  let input = e.target.value;
                  input = input
                    .toUpperCase()
                    .replace(/[^A-Z0-9\s]/g, "")
                    .replace(/\s+/g, " ")
                    .trimStart()
                    .slice(0, 100);

                  e.target.value = input;
                  e.target.setSelectionRange(start, end);
                }}
              />
              <button className="rm-dropdown-btn">
                <span
                  className="icon-right-arrow-triangle"
                  onClick={() => setRmShow(!rmShow)}
                ></span>
              </button>
              {rmShow && (
                <>
                  <ul
                    className="rm-mapping-ap border-0"
                    onScroll={handleRmScroll}
                    id="getRm_code"
                  >
                    {rmVal.map((item, i) => (
                      <li
                        key={i}
                        className="rm-maping-item-wrapper"
                        onClick={() => {
                          document.querySelector("#SearchInput_Rm").value =
                            item.label;
                          setRmShow(false);
                          setRmName({value: item?.value, label: item?.label});
                        }}
                      >
                        <div> {item?.label}</div>
                        <div> {item?.value}</div>
                      </li>
                    ))}
                    {scrollRmLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                    {errorClientRmName && (
                      <div className="rm-maping-no-data">
                        {errorClientRmName}
                      </div>
                    )}
                  </ul>
                </>
              )}

              {/* <span className="search-error">{error}</span> */}
            </div>
          </div>
        </div>
        <div className="col-md-2 col-sm-6 col-6">
          <div className="form-group">
            <label className="form-label">{Constants.Client_Search} </label>
            {/* <div className="for-position"> */}
            <input
              type="text"
              name="search-text"
              id="SearchInput"
              placeholder="Search here..."
              className="input-st"
              autoComplete="off"
              value={searchVal}
              onChange={(e) =>
                setSearchVal(e?.target?.value?.toUpperCase())
                // RMClientMappingReport("grid", e.target.value)
              }
              onInput={(e) => {
                const start = e.target.selectionStart;
                const end = e.target.selectionEnd;
                let input = e.target.value;
                input = input
                  .toUpperCase()
                  .replace(/[^A-Z0-9\s]/g, "")
                  .replace(/\s+/g, " ")
                  .trimStart()
                  .slice(0, 100);

                e.target.value = input;
                e.target.setSelectionRange(start, end);
              }}
            />
          </div>
        </div>
        <div className="col-md-2 col-sm-6 col-6">
          <button
            className="generate-btn text-green mt-3"
            value="excel"
            onClick={(e) => RMClientMappingReport("excel", "")}
          >
            <>
              <span className="icon-excelsvg"></span>
              {"Excel"}
            </>
          </button>
        </div>
      </div>

      <div className="save-btn">
        {isupdate ? (
          <>
            {" "}
            <button
              className="margin-save"
              onClick={() => 
                handleSaveSubmit("update")
                // UpdateClientRM(clientID, rmName)
              }
            >
              Update
            </button>
          </>
        ) : (
          <>
            {" "}
            <button
              className="margin-save"
              onClick={() => 
                handleSaveSubmit("save")
                // saveClientName(clientCode, rmName)
              }
            >
              Save
            </button>
          </>
        )}

        <button className="margin-reset" onClick={reset}>
          Reset
        </button>
      </div>
      <div className="for-grid-section pnl-wrapper">
        {loaderMain ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : rmReport && rmReport?.length > 0 ?
          (
            <ClientrmTable
              serverError={serverError}
              rmReport={rmReport}
              childUpdate={childUpdate}
            />
          ) : serverError ?
            (<h4 className="report-error-message">
              {noDataFound(serverError)}
            </h4>
            )
            : (
              tableErr && noDataFound(tableErr)
            )
        }
      </div>
    </div>
  );
}

export default ClientrmMapping;
